export default "__VITE_ASSET__DxXw2VZg__"